import { environment } from './../environments/environment';

export class AppSettings {
	public static apiEndpoint = environment.apiEndpoint;
	public static version = environment.version;
	public static channel = environment.channel;
}
